import { render } from "./WeeksComponent.vue?vue&type=template&id=787f18c3"
import script from "./WeeksComponent.vue?vue&type=script&lang=js"
export * from "./WeeksComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__